module.exports = __webpack_public_path__ + "static/media/陆表场景制备平台.145781f4.jpg";